import { createSlice } from '@reduxjs/toolkit';
import { createGuestAnswersBuilder, fetchRSVPDetailsBuilder, findGuestBuilder } from './builder';

const initialState = {
  findGuestPending: false,
  fetchRSVPDetailsPending: false,
  createGuestAnswersPending: false,

  key: null,
  id: null,
  brideName: '',
  groomName: '',
  venueName: '',
  venueAddress: '',
  dateOfWedding: '',
  rehearsalDinner: false,
  rehearsalVenueName: '',
  dateOfRehearsalDinner: null,
  rehearsalVenueAddress: '',
  questions: [],

  invitationGuestMembers: {
    data: [],
  },

  guestInfo: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
  },
  guestAnswers: [],

  guestFlow: {
    numOfGuest: 0,
    currentGuestOnFlowId: null,
    finished: 0,
  },
};
// state.invitationGuestMembers.data = data;
//     state.guestAnswers = data.map(guest => {
//       return { id: guest.id };
//     });
//     state.guestFlow.numOfGuest = data.length;
//   });
export const rsvpSlice = createSlice({
  name: 'rsvpInfo',
  initialState,
  reducers: {
    resetGuestData(state) {
      state.invitationGuestMembers = {
        data: [],
      };
      state.guestAnswers = [];
      state.guestFlow = {
        numOfGuest: 0,
        currentGuestOnFlowId: null,
        finished: 0,
      };
    },
    setGuestInformationAnConfirmation(state, { payload }) {
      state.guestAnswers = state.guestAnswers.map(guest => {
        if (guest.id === payload.id) {
          guest.confirm = payload.confirm;
          guest.firstName = payload.firstName;
          guest.lastName = payload.lastName;
          guest.email = payload.email;
          guest.phoneNumber = payload.phoneNumber;
          guest.attendingRehearsalDinner = payload.attendingRehearsalDinner;
          guest.finished = payload.finished;
        }
        return guest;
      });
      state.invitationGuestMembers.data = state.invitationGuestMembers.data.map(guest => {
        if (guest.id === payload.id) {
          guest.firstName = payload.firstName;
          guest.lastName = payload.lastName;
        }
        return guest;
      });
    },

    setGuestContactAndRehearsal(state, { payload }) {
      state.guestAnswers = state.guestAnswers.map(guest => {
        if (guest.id === payload.id) {
          guest.email = payload.email;
          guest.phoneNumber = payload.phoneNumber;
          guest.attendingRehearsalDinner = payload.attendingRehearsalDinner;
        }
        return guest;
      });
    },

    setGuestFlowCurrentGuestId(state, { payload }) {
      state.guestFlow.currentGuestOnFlowId = payload;
    },

    setCurrentGuestIdAndFinished(state, { payload }) {
      state.guestFlow.currentGuestOnFlowId = payload.currentGuestOnFlowId;
      state.guestFlow.finished = payload.finished;
    },

    setGuestQuestionAnswersAndFinish(state, { payload }) {
      state.guestAnswers = state.guestAnswers.map(guest => {
        if (guest.id === payload.id) {
          return { ...guest, ...(payload.selectedAnswers && { answers: payload.selectedAnswers }), finished: true };
        }
        return guest;
      });
    },
  },
  extraReducers: builder => {
    findGuestBuilder(builder);
    fetchRSVPDetailsBuilder(builder);
    createGuestAnswersBuilder(builder);

    builder.addCase('logout', () => initialState);
  },
});
export const selectRSVPInfo = state => state.rsvpInfo;
export const selectFetchRSVPDetailsPending = state => state.rsvpInfo.fetchRSVPDetailsPending;

export const selectGuestInfo = state => state.rsvpInfo.guestInfo;
export const selectFindGuestPending = state => state.rsvpInfo.findGuestPending;
export const selectInvitationGuestMembers = state => state.rsvpInfo.invitationGuestMembers;

export const selectGuestAnswers = state => state.rsvpInfo.guestAnswers;

export const selectGuestFlow = state => state.rsvpInfo.guestFlow;

export const selectCreateGuestAnswersPending = state => state.rsvpInfo.createGuestAnswersPending;

export const {
  setGuestFlowCurrentGuestId,
  setGuestContactAndRehearsal,
  setCurrentGuestIdAndFinished,
  setGuestQuestionAnswersAndFinish,
  resetGuestData,
  setGuestInformationAnConfirmation,
} = rsvpSlice.actions;

export default rsvpSlice.reducer;
